module.exports = __webpack_public_path__ + "img/listen-on-stitcher.f3257b3f.png";